import React, { useState } from "react";
import { __ } from "services/Translator";
import supportApi from "support/api/supportApi";

// Asked only when the server says the conversation is eligible: terminal status
// and not already rated. The frontend never decides that, it just renders what
// csat.eligible said, so a reopened or already-rated thread cannot be scored
// twice from a stale panel.
const SCORES = [1, 2, 3, 4, 5];

export default function CsatForm({ reference, onSubmitted }) {
  const [score, setScore] = useState(null);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(null);

  const submit = async (event) => {
    event.preventDefault();
    if (!score || submitting) {
      return;
    }
    setSubmitting(true);
    setError(null);
    const response = await supportApi.submitCsat(reference, {
      score,
      comment: comment.trim() || undefined,
    });
    setSubmitting(false);

    if (response.status === 200) {
      setDone((response.data && response.data.message) || __("Thank you for your feedback"));
      if (onSubmitted) {
        onSubmitted();
      }
      return;
    }
    setError(__("We could not send your rating. Please try again."));
  };

  if (done) {
    return (
      <p className="supCsatDone" role="status">
        {done}
      </p>
    );
  }

  return (
    <form className="supCsat" onSubmit={submit}>
      <fieldset className="supCsatScores">
        <legend className="supLabel">{__("How did we do?")}</legend>
        {SCORES.map((value) => (
          <label key={value} className={"supCsatScore" + (score === value ? " isPicked" : "")}>
            <input
              type="radio"
              name={"csat-" + reference}
              value={value}
              checked={score === value}
              onChange={() => setScore(value)}
              className="visuallyHidden"
            />
            <span aria-hidden="true">{value}</span>
            <span className="visuallyHidden">
              {value === 1 ? __("Very poor") : value === 5 ? __("Very good") : String(value)}
            </span>
          </label>
        ))}
      </fieldset>

      <label className="visuallyHidden" htmlFor={"csat-comment-" + reference}>
        {__("Anything you would like to add?")}
      </label>
      <textarea
        id={"csat-comment-" + reference}
        className="supInput supTextarea"
        rows={2}
        value={comment}
        placeholder={__("Anything you would like to add?")}
        onChange={(event) => setComment(event.target.value)}
      />

      {error && <p className="supFieldError">{error}</p>}

      <button type="submit" className="supBtn supBtnPrimary" disabled={!score || submitting}>
        {submitting ? __("Sending") : __("Send rating")}
      </button>
    </form>
  );
}
